import { defineCatalogue } from '../../../i18n';

export const territoryCatalogue = defineCatalogue(
  {
    title: 'Território',
    'scope.none': 'Esta campanha ainda não tem um território configurado.',
    'election.none':
      'O eleitorado aparece quando a candidatura estiver vinculada ao cadastro do TSE em Dados da campanha.',
    'electorate.unloaded':
      'O eleitorado por seção desta eleição ainda não foi carregado do TSE. O mapa e as leituras das contas seguem abaixo.',

    'electorate.label': 'Eleitorado',
    'electorate.caption': 'pessoas aptas a votar em {locality}, pelo cadastro do TSE',
    'electorate.sections.label': 'Seções eleitorais',
    'electorate.turnout.label': 'Comparecimento',

    'breakdown.title': 'Por dimensão',

    'localities.title.neighborhood': 'Bairros',
    'localities.title.municipality': 'Municípios',
    'localities.title.state': 'Estados',
    'localities.metric.label': 'O que o ranking mostra',
    'localities.metric.reach': 'Alcance',
    'localities.metric.trend': 'Maior variação de alcance',
    'localities.metric.comments': 'Comentários',
    'localities.empty': 'Nenhuma conta monitorada publicou daqui no período',
    'delta.against': 'em relação ao período anterior',

    'movement.title': 'Movimento',
    'movement.rise': 'Maior alta',
    'movement.fall': 'Maior queda',
    'movement.rise.none': 'Nada subiu no período',
    'movement.fall.none': 'Nada caiu no período',

    // The screen itself no longer mounts this card (`CompositionCard`,
    // owner ruling), but the assistant's card dispatcher still does
    // (`assistant/cards.ts`), so the strings stay.
    'composition.title': 'Idade de quem vota',
    'composition.chart': 'Composição do eleitorado',
    'composition.showAll': 'Ver tudo ({count})',

    'map.label': 'Mapa do território',
    'map.attribution':
      'Limites municipais e de bairros: IBGE · Demais limites: © colaboradores do OpenStreetMap (ODbL)',
    'map.zoomIn': 'Ampliar',
    'map.zoomOut': 'Reduzir',
    'map.attributionToggle': 'Fontes do mapa',
    'map.unavailable.title': 'Mapa indisponível',
    'map.unavailable.absent': 'Esta campanha ainda não tem um mapa do território.',
    'map.unavailable.unreadable': 'O mapa do território não pôde ser carregado.',
    'map.legend': 'Escala do mapa, até {max}',
  },
  {
    title: 'Territory',
    'scope.none': 'This campaign has no territory configured yet.',
    'election.none':
      'The electorate appears once the candidature is linked to the TSE register in the campaign record.',
    'electorate.unloaded':
      'This election’s electorate by section has not been loaded from the TSE yet. The map and the accounts’ readings are below.',

    'electorate.label': 'Electorate',
    'electorate.caption': 'people eligible to vote in {locality}, from the TSE register',
    'electorate.sections.label': 'Electoral sections',
    'electorate.turnout.label': 'Turnout',

    'breakdown.title': 'By dimension',

    'localities.title.neighborhood': 'Neighbourhoods',
    'localities.title.municipality': 'Municipalities',
    'localities.title.state': 'States',
    'localities.metric.label': 'What the ranking shows',
    'localities.metric.reach': 'Reach',
    'localities.metric.trend': 'Largest change in reach',
    'localities.metric.comments': 'Comments',
    'localities.empty': 'No monitored account posted from here in this period',
    'delta.against': 'against the previous period',

    'movement.title': 'Movement',
    'movement.rise': 'Largest rise',
    'movement.fall': 'Largest fall',
    'movement.rise.none': 'Nothing rose in this period',
    'movement.fall.none': 'Nothing fell in this period',

    'composition.title': 'Age of those who vote',
    'composition.chart': 'Electorate composition',
    'composition.showAll': 'Show all ({count})',

    'map.label': 'Territory map',
    'map.attribution':
      'Municipal and neighbourhood boundaries: IBGE · Other boundaries: © OpenStreetMap contributors (ODbL)',
    'map.zoomIn': 'Zoom in',
    'map.zoomOut': 'Zoom out',
    'map.attributionToggle': 'Map sources',
    'map.unavailable.title': 'Map unavailable',
    'map.unavailable.absent': 'This campaign has no territory map yet.',
    'map.unavailable.unreadable': 'The territory map could not be loaded.',
    'map.legend': 'Map scale, up to {max}',
  },
);

export const tt = territoryCatalogue.t;
